import o from "react";
const e = o.createContext({
  onRetry: () => {
  }
}), t = e.Provider, n = e.Consumer;
export {
  n as FileUploaderConsumer,
  e as FileUploaderContext,
  t as FileUploaderProvider,
  e as default
};
